// /** COLORS */
// exportconst colorPlayWhite ='#ffffff';
// exportconst colorPlayGrey1 ='#e6ebeb';
// exportconst colorPlayGrey2 ='#647378';
// exportconst colorPlayGrey3 ='#2e3233';
// exportconst colorPlayGrey4 ='#222526';
// exportconst colorPlayGrey5 ='#171a1a';
// exportconst colorPlayGrey6 ='#0b0c0d';
// exportconst colorPlayBlack ='#000000';

// exportconst colorPlayGreen1 ='#00c800';

// exportconst colorPlayBlue2 ='#0f418c';
// exportconst colorPlayBlue3 ='#008de9';

// exportconst colorPlayRed1 ='#e13241';
// exportconst colorPlayRed2 ='#b9232d';

// exportconst colorPlayYellow1 ='#ffdc8c';
export const colorPlayYellow2 = '#fcc346';

// //Brand
// exportconst colorPlayBrandBlue1 ='#0f418c';
// exportconst colorPlayBrandBlue2 ='#1e69aa';

// exportconst colorPlayBrandPurple1 ='#641e78';
// exportconst colorPlayBrandPurple2 ='#410f5a';

// exportconst colorPlayBrandGreen1 ='#197869';
// exportconst colorPlayBrandGreen2 ='#2d9b91';

/** COLORS */
export const regularWhite = '#ffffff';
export const extraLightCoolGrey = '#e6ebeb';
export const darkCoolGrey = '#647378';
export const playGrey20 = '#2e3233';
export const playGrey15 = '#222526';
export const playGrey10 = '#171a1a';
export const playGrey5 = '#0b0c0d';
export const regularBlack = '#000000';

export const accentGreen = '#00c800';

export const darkBlue = '#1e69aa';
export const extraDarkBlue = '#0f418c';
export const accentBlue = '#0091ff';

export const regularRed = '#e13241';
export const darkRed = '#b9232d';

export const lightYellow = '#ffdc8c';
export const regularYellow = '#ffc346';

export const darkPurple = '#641e78';
export const extraDarkPurple = '#410f5a';

export const extraDarkTurquoise = '#197869';
export const darkTurquoise = '#2d9b91';

/** SCREEN SIZES */
export const xsmall = '29.6423em'; // 474px
export const small = '37.5625em'; // 601px
export const medium = '50.0625em'; // 801px
export const large = '64.0625em'; // 1025px
export const xlarge = '80.0625em'; // 1281px
export const fullScreen = '120.0625em'; // 1921px

/** FONT WEIGHTS */
export const fontWeightLight = 300;
export const fontWeightRegular = 400;
export const fontWeightBold = 700;

/** MARGINS */
export const defaultTextMargin = '0.1em';

/** TRANSITIONS */
export const playTransitionEasing = 'cubic-bezier(0.5, 0, 0.1, 1)';
export const playTransitionDescription = 'cubic-bezier(0.18, 0.61, 0.43, 0.95)';
export const playTransitionRecommendations = 'cubic-bezier(0.25, 0.1, 0.25, 1)';
export const playTransitionCubicEaseInOut = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

/** ICONS */
export const iconPlay = '\f12e';
export const iconBan = '\f10c';
export const iconArrowLeft = '\f107';
export const iconArrowRight = '\f108';
export const iconClose = '\f111';
export const iconAngleLeft = '\f103';
export const iconAngleRight = '\f104';
export const iconPointRight = '\f104';
export const iconArrowDown = '\f106';
export const iconAudioDescribed = '\f136';
export const iconSignInterpretation = '\f137';
export const iconInformationFilled = '\f11f';
export const iconExternal = '\f124';
export const iconInfoFilled = '\f11f';
export const iconWarningFilled = '\f14a';

export const svgIconPlay =
    'PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIzMCIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC44Ii8+PHBhdGggZD0iTTI0IDE4VjQzTDQyIDMwLjVMMjQgMThaIiBmaWxsPSJibGFjayIvPjwvc3ZnPg==';
export const svgIconPlayOpaque =
    'PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIzMCIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMS4wIi8+PHBhdGggZD0iTTI0IDE4VjQzTDQyIDMwLjVMMjQgMThaIiBmaWxsPSJibGFjayIvPjwvc3ZnPg==';
